import type { FaireProductEntity } from "../../entity_types/product";

export const lj_pdp_cubic_table_lamp: FaireProductEntity = {
  token: "lj-pdp-cubic-table-lamp",
  type: "product",
  name: "Cubic Table Lamp",
  brandName: "Misewell",
  brandToken: "brand_proto_misewell",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/259c9bd199b6fd0a69541bf48e154c8fc3c2fac8e7d39aa616b37fce6a955d32.webp",
  galleryImageUrls: [
    "https://cdn.prerelease.faire.dev/fastly/259c9bd199b6fd0a69541bf48e154c8fc3c2fac8e7d39aa616b37fce6a955d32.webp",
    "https://cdn.prerelease.faire.dev/fastly/2a6ca115955ee7fa0eb159e8c05c4d0b6e9cdaeef8fa05a6b8d467e6dc39cd09.webp",
    "https://cdn.prerelease.faire.dev/fastly/b7746c7895e9df53367707abb3ea17d30f14e7ff3e4a137837f0c2d1e749ca10.webp",
    "https://cdn.prerelease.faire.dev/fastly/7b0108d085017ccb44ed5e95b0ff5258f1b8c1bbe54cd044192442aea2222fff.webp",
    "https://cdn.prerelease.faire.dev/fastly/0df6f03900eccfb61f09216b82f305c98fd7a5cbd623880a66ab7eae38371801.webp",
    "https://cdn.prerelease.faire.dev/fastly/b3503ac0d6e409146515fd732ade635576645ea9ce25f9e3162a5e8b7af7f2fb.webp",
    "https://cdn.prerelease.faire.dev/fastly/b8b02598cf4e67e63c3dd309c38bc9ec235bc3e10272e9dd6dd6f1f470d0a781.webp",
    "https://cdn.prerelease.faire.dev/fastly/8fb4a9ff5cc7c0c0d2afc87eff190e471926c06931840d2956aeed437034d776.webp",
  ],
  colorOptions: ["Coral", "White", "Black"],
  priceDollars: 159.5,
  msrpDollars: 319,
  description:
    'This dual purpose lamp works great as a table lamp or a sconce. When lit, the blown glass globe appears to float atop the handmade ceramic base. This item is made by hand in the Misewell ceramics studio.\n\nThis lamp is UL Listed.\n\n6W x 6D x 8H"\n\nMADE IN USA\n\n(Wisconsin)',
  details:
    "Made in United States\n\nProduct Language: English\n\nWeight: 3 lb (1.36 kg)",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "lj-pdp-fallback-migration",
  },
};
